export default {
  apiKey: "AIzaSyC2qQfz8YT3zD7s3PJRrkRbrwjOpcGu_fM",
  authDomain: "arctic-cool-j10j.firebaseapp.com",
  projectId: "arctic-cool-j10j",
  storageBucket: "arctic-cool-j10j.appspot.com",
  messagingSenderId: "458584379157",
  appId: "1:458584379157:web:6ea4ecd0c815de2dc4631c"
};
